import React from "react";

export class StaticField extends React.PureComponent {
  render() {
    return this.props.children;
  }
}
